import { Fragment, useEffect, useState } from "react"
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import _ from "underscore";
import config from "../config";
import Icon from "./Icons";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

import { ForeignLabel, FilterHelp, RangeInput } from "./Elements";
import PeriodsHistogram from "./PeriodsHistogram";
import helpers from "../helpers";
import MapView from "./MapView";

export default function DocumentListFilterWrapper(props) {
	const l = window.l;

	const [languagesOptions, setLangugesOptions] = useState(null);
	const [keywordsOptions, setKeywordsOptions] = useState(null);
	const [roleOptions, setRoleOptions] = useState(null);
	const [repositoryOptions, setRepositoryOptions] = useState(null);
	//const [yearsHistogramData, setYearHistogramData] = useState(null);
	//const [yearsMax, setYearsMax] = useState(0);

	const filters = [
		{
			label: l('Search'),
			type: 'text',
			searchParam: 'leit',
			baseValue: '',
			hideInSideBar: true
		},
		{
			label: l('Place'),
			type: 'foreignId',
			searchParam: 'stadur',
			baseValue: null,
			hideInSideBar: true,
			apiEndpoint: 'farms',
			labelEndpointField: 'name',
			baseValue: ''
		},
		{
			label: l('Bundle'),
			type: 'foreignId',
			searchParam: 'boggull',
			apiEndpoint: 'bundles',
			labelEndpointField: '__str__'
		},
		{
			label: l('Charter collection'),
			type: 'choices',
			searchParam: 'safnmark',
			data: {
				'': '',
				'AM Dipl. Dan.': 'AM Dipl. Dan.',
				'AM Dipl. Isl.': 'AM Dipl. Isl.',
				'AM Dipl. Norv.': 'AM Dipl. Norv.'
			},
			baseValue: '',
		},
		{
			label: l('Repository'),
			type: 'checklist',
			searchParam: 'safn',
			data: repositoryOptions,
			listLabelFunc: (item, activeFilter) => {
				return l(item.organisation)
			},
			filterLabelFunc: (item) => <ForeignLabel 
				apiEndpoint={'repository'} 
				labelEndpointField={'organisation'} 
				idValue={item} 
				labelFunc={(label) => window.l(label)}
			/>,
			baseValue: []
		},
		{
			label: l('Time period'),
			infoLabel: l('E.g. 1500-1530'),
			type: 'range',
			searchParam: 'timabil',
			//validator: '^[0-9]{4}\-[0-9]{4}$',
			baseValue: [],
			helpText: l('Search for documents with year of act within a range of years (1500-1560) or on a single year (1545).')
		},
		{
			label: l('Document type'),
			type: 'checklist',
			listLabelField: 'label',
			searchParam: 'tegund',
			data: [
				{
					label: l('Original'),
					id: 'original'
				},
				{
					label: l('Apograph'),
					id: 'apograph'
				},
				{
					label: l('Transcript'),
					id: 'transcript'
				},
				{
					label: l('Forgery'),
					id: 'forgery'
				},
				{
					label: l('Other'),
					id: 'other'
				}
			],
			baseValue: [],
			helpText: l('')
		},
		{
			label: l('Language'),
			type: 'checklist',
			listLabelFunc: (item) => l(item.language),
			filterLabelFunc: (item) => <ForeignLabel 
				apiEndpoint={'languages'} 
				labelEndpointField={'language'} 
				idValue={item} 
				labelFunc={(label) => window.l(label)}
			/>,
			searchParam: 'tungumal',
			data: languagesOptions,
			baseValue: [],
			helpText: l('')
		},
		{
			label: l('Keyword'),
			type: 'checklist',
			listLabelFunc: (item, activeFilter) => {
				return l(item.keyword)
			},
			filterLabelFunc: (item) => <ForeignLabel 
				apiEndpoint={'keyword'} 
				labelEndpointField={'keyword'} 
				idValue={item} 
				labelFunc={(label) => window.l(label)}
			/>,
			searchParam: 'lykilord',
			data: keywordsOptions,
			baseValue: [],
			helpText: l('')
		},
		{
			label: l('Writing support'),
			type: 'choices',
			searchParam: 'efni',
			data: {
				'': '',
				'parchment': l('Parchment'),
				'paper': l('Paper'),
				'parchment and paper': l('Parchment and paper')
			},
			baseValue: '',
			helpText: l('')
		},
		{
			label: l('Person names'),
			type: 'text',
			searchParam: 'einstaklingur_nafn',
			hideInSideBar: false
		},
		{
			label: l('Role'),
			type: 'choicesdynamic',
			listLabelFunc: (item) => l(item.__str__),
			filterLabelFunc: (item) => <ForeignLabel 
				apiEndpoint={'role'} 
				labelEndpointField={'__str__'} 
				idValue={item} 
				labelFunc={(label) => window.l(label)}
			/>,
			apiEndpoint: 'role',
			labelEndpointField: '__str__',
			searchParam: 'hlutverk',
			dependsOn: 'einstaklingur_nafn',
			data: roleOptions,
			baseValue: '',
			helpText: l('')
		},
		{
			label: l('Place name'),
			type: 'text',
			searchParam: 'stadarnafn',
			baseValue: '',
			hideInSideBar: false
		},
		{
			label: l('Person'),
			type: 'foreignId',
			searchParam: 'einstaklingur',
			baseValue: null,
			hideInSideBar: true,
			apiEndpoint: 'person',
			labelEndpointField: 'name',
			baseValue: ''
		}

	];

	const baseFiltersState = filters.filter(filter => filter.searchParam).reduce(function(map, filter) {
		map[filter.searchParam] = filter.baseValue;
		return map;
	}, {});

	const invisibleFilters = []; //['timabil']; // Filters that are not visible above the document list component

	const [minYear, setMinYear] = useState(1100);
	//const minYear = baseFiltersState.timabil[0];
	const [maxYear, setMaxYear] = useState(1850);
	//const maxYear = baseFiltersState.timabil[1];

	const sliderMarks = helpers.createSliderMarks(minYear, maxYear);

	const [selectedFilters, setSelectedFilters] = useState(baseFiltersState);
	const [activeFilters, setActiveFilters] = useState(baseFiltersState);
	const [hasActiveFilters, setHasActiveFilters] = useState(false);
	const [searchParams, setSearchParams] = useSearchParams();

	const [timeRangeValue, setTimeRangeValue] = useState();

	const navigate = useNavigate();

	const resetParamsFromFilter = ['sida'];

	const checkValidator = (filter, value) => {
		if (!filter.validator) {
			return true;
		}
		else {
			return Boolean(value.match(new RegExp(filter.validator)))
		}
	}

	const addOrRemove = (array, value) => {
		var index = array.indexOf(value);
	
		if (index === -1) {
			array.push(value);
		} else {
			array.splice(index, 1);
		}

		return array;
	}
	
	useEffect(() => {
		if (!languagesOptions) {
			fetch(config.apiRoot+'languages')
				.then(res => res.json())
				.then(json => setLangugesOptions(json.results));
		}
		if (!keywordsOptions) {
			fetch(config.apiRoot+'keyword')
				.then(res => res.json())
				.then(json => setKeywordsOptions(json.results));
		}
		if (!roleOptions) {
			fetch(config.apiRoot+'role')
				.then(res => res.json())
				.then(json => setRoleOptions(json.results));
		}
		if (!repositoryOptions) {
			fetch(config.apiRoot+'repository')
				.then(res => res.json())
				.then(json => setRepositoryOptions(json.results));
		}
	}, []);

	useEffect(() => {
		let _activeFilters = baseFiltersState;

		for (let entry of searchParams.entries()) {
			_activeFilters[entry[0]] = entry[1].split(',').map(val => {
				return /^\d+$/.test(val) ? parseInt(val) : val;
			});
		}

		setSelectedFilters(_activeFilters);
		setActiveFilters(_activeFilters);

		updateHasActiveFilters(_activeFilters);
	}, [searchParams]);

	const updateHasActiveFilters = (filters) => {
		let _hasActiveFilters = false;

		let _activeFilters = filters || JSON.parse(JSON.stringify(activeFilters));

		for (let key in _activeFilters) {
			if (_activeFilters[key] && _activeFilters[key].length > 0 && invisibleFilters.indexOf(key) == -1) {
				_hasActiveFilters = true;
			}
		}

		setHasActiveFilters(_hasActiveFilters);
	}

	const updateUrl = (selectedFilters) => {
		let urlParams = Object.keys(selectedFilters).map(key => selectedFilters[key] && 
			selectedFilters[key].toString().length > 0 && 
			resetParamsFromFilter.indexOf(key) == -1 ? 
			key+'='+(selectedFilters[key].join ? selectedFilters[key].join(',') : selectedFilters[key]) : null
		).filter(n => n);

		updateHasActiveFilters();

		navigate('/archive/?'+urlParams.join('&'))
	}

	const updateSelectedFilters = (paramName, value, doUpdate) => {
		let _selectedFilters = JSON.parse(JSON.stringify(selectedFilters));

		_selectedFilters[paramName] = value;

		setSelectedFilters(_selectedFilters);

		if (doUpdate) {
			setActiveFilters(_selectedFilters);
			updateUrl(_selectedFilters);
			//setTimeout(() => updateUrl(), 200);
		}
	}

	const localeSort = (items, listLabelFunc) => {
		const sortCollator = new Intl.Collator('is', { sensitivity: 'base' });
	
		return items.sort((a, b) => {
			const labelA = listLabelFunc(a);
			const labelB = listLabelFunc(b);
			return sortCollator.compare(labelA, labelB);
		})
	}

	window._selectedFilters = selectedFilters;

	return <Fragment>

			<div className="mb-10 bg-gray-100 px-10 py-8 rounded lg:sticky top-2 z-[1000] shadow-md border border-gray-300">
				<div className="font-bold mb-5">{l('Search the archive')}</div>

				<input type="text" value={selectedFilters['leit']} 
					className="p-2 block w-full rounded border border-gray-300 shadow focus:shadow-gray outline-1"
					onChange={(event) => {
						updateSelectedFilters('leit', event.target.value);
					}}
					onKeyDown={(event) => {
						if (event.key == 'Enter') {
							updateUrl(selectedFilters);
						}
					}} 
				/>
			</div>

		<div className="lg:flex gap-6">

			<div className="lg:w-1/5">

				{
					filters.filter(filter => !filter.hideInSideBar).map((filter, index) => {
						return <div key={index} className="mb-5 relative">
							{
								filter.helpText && <FilterHelp helpText={filter.helpText} helpLink={filter.helpLink} />
							}
							{
								filter.type == 'label' && <div className="border-t pt-5 border-1 border-gray-200 font-bold mb-5">{filter.label}</div>
							}
							{
								filter.type == 'checklist' && <Fragment>
									{
										filter.label && <div className="font-bold mb-5">{filter.label}</div>
									}
									<div className="flex flex-col gap-1 max-h-[80px] lg:max-h-[300px] overflow-y-auto minimal-scrollbar pb-5 border-b border-1 border-gray-200">
										{
											filter.data && (filter.listLabelFunc ? localeSort(filter.data, filter.listLabelFunc) : filter.data).map((item, iIndex) => <label key={iIndex}><input className="size-4 border border-1 border-gray-200 mr-2" onChange={(event) => {
												updateSelectedFilters(filter.searchParam, addOrRemove(selectedFilters[filter.searchParam], item.id), true);
											}} checked={selectedFilters[filter.searchParam].indexOf(item.id) > -1} type={'checkbox'} />{filter.listLabelFunc ? filter.listLabelFunc(item) : filter.listLabelField ? (typeof filter.listLabelField === 'object' ? item[filter.listLabelField[props.currentLang]] : item[filter.listLabelField]) : ''}</label>)
										}
									</div>
								</Fragment>
							}
							{
								filter.type == 'choicesdynamic' && <Fragment>
									{
										filter.label && <div className="font-bold mb-5">{filter.label}</div>
									}
									<div className="flex flex-col gap-1 max-h-[80px] lg:max-h-[300px] overflow-y-auto minimal-scrollbar pb-5 border-b border-1 border-gray-200">
										<select className="p-2 block w-full rounded border border-gray-300 shadow focus:shadow-gray outline-1" disabled={filter.dependsOn ? !selectedFilters[filter.dependsOn] && selectedFilters[filter.dependsOn] == '' : false} value={selectedFilters[filter.searchParam]} onChange={(event) => {
												updateSelectedFilters(filter.searchParam, event.target.value, true);
										}}>
											<option value={-1}></option>
											{
												filter.data && (filter.listLabelFunc ? _.sortBy(filter.data, (item) => filter.listLabelFunc(item)) : filter.data).map((item, iIndex) => <option key={iIndex} value={item.id}>{filter.listLabelFunc ? filter.listLabelFunc(item) : filter.listLabelField ? (typeof filter.listLabelField === 'object' ? item[filter.listLabelField[props.currentLang]] : item[filter.listLabelField]) : ''}</option>)
											}
										</select>
									</div>
								</Fragment>
							}
							{
								filter.type == '_choices' && <Fragment>
									<div className="font-bold mb-1">{filter.label}</div>
									<div className="relative pb-5">
										<select className="p-2 block w-full rounded border border-gray-300 shadow focus:shadow-gray outline-1" disabled={filter.dependsOn ? !selectedFilters[filter.dependsOn] && selectedFilters[filter.dependsOn] == '' : false} value={selectedFilters[filter.searchParam]}
											onChange={(event) => {
												updateSelectedFilters(filter.searchParam, event.target.value, true);
											}}
										>
											{
												Object.keys(filter.data).map((key, iIndex) => <option key={iIndex} value={key}>{filter.data[key]}</option>)
											}
										</select>
									</div>
								</Fragment>
							}
							{
								filter.type == 'text' && <Fragment>
									{
										filter.label && <div className="font-bold mb-5">{filter.label}</div>
									}
									<div className="relative pb-5">
										<input type="text" value={selectedFilters[filter.searchParam]} 
											className="p-2 block w-full rounded border border-gray-300 shadow focus:shadow-gray outline-1"
											onChange={(event) => {
												updateSelectedFilters(filter.searchParam, event.target.value);
											}}
											onKeyDown={(event) => {
												if (event.key == 'Enter') {
													updateUrl(selectedFilters);
												}
											}} 
										/>
									</div>
								</Fragment>
							}
							{
								filter.type == 'checkbox' && <label><input className="size-4 border border-1 border-gray-200 mr-2" onChange={(event) => {

									//updateSelectedFilters(filter.searchParam, addOrRemove(selectedFilters[filter.searchParam], filter.checkedValue), true);

									updateSelectedFilters(filter.searchParam, (event.target.checked ? filter.checkedValue : ''), true);
								}} checked={selectedFilters[filter.searchParam] == filter.checkedValue} type={'checkbox'} />{filter.label}</label>
							}
							{
								filter.type == 'range' && <Fragment>
								{
									filter.label && <div className="font-bold mb-5">{filter.label}</div>
								}
								<div className="relative pb-5">
									<RangeInput value={selectedFilters[filter.searchParam]}
										className="p-2 block w-full rounded border border-gray-300 shadow focus:shadow-gray outline-1"
										onChange={(event) => {
											updateSelectedFilters(filter.searchParam, event.target.value);
										}}
										onEnter={(event) => {
											if (checkValidator(filter, event.target.value)) {
												updateUrl(selectedFilters);
											}
										}} 
									/>
								</div>
								{
									filter.infoLabel && <div className="text-gray-600 -mt-4 mb-2">{filter.infoLabel}</div>
								}
							</Fragment>
							}
							{
								filter.type == 'choices' && <Fragment>
									<div className="font-bold mb-1">{filter.label}</div>
									<div className="relative pb-5">
										<select className="p-2 block w-full rounded border border-gray-300 shadow focus:shadow-gray outline-1" value={selectedFilters[filter.searchParam]}
											onChange={(event) => {
												updateSelectedFilters(filter.searchParam, event.target.value, true);
											}}
										>
											{
												Object.keys(filter.data).map((key, iIndex) => <option key={iIndex} value={key}>{filter.data[key]}</option>)
											}
										</select>
									</div>
								</Fragment>
							}

						</div>
					})
				}

			</div>

			<div className="lg:w-4/5">

				<div className="font-bold mb-5">{l('Time period')}</div>
				<div className="pb-5 border-b mb-5">

					<div className="mx-2 mb-5">
						<div className="flex w-full justify-around hidden">
							{
								Object.keys(sliderMarks).slice(0, -1).map((mark, index) => <button key={index} className="opacity-0 group-hover:opacity-100 text-xs border border-1 rounded border-gray-200 h-4 grow mx-1 hover:bg-gray-200" onClick={() => {
									setTimeRangeValue([parseInt(mark), parseInt(mark)+50]);
									updateSelectedFilters('timabil', [parseInt(mark), parseInt(mark)+50], true);
								}}>{/*mark+'-'+(parseInt(mark)+50)*/}</button>)
							}
						</div>

						<PeriodsHistogram sliderMarks={sliderMarks} 
							onSelect={(event) => {
								setTimeRangeValue(event);
								updateSelectedFilters('timabil', event, true);
							}}
							onPeriods={(period) => {
								setMinYear(period[0]);
								setMaxYear(period[1]);
							}} />

						<Slider min={minYear} 
							max={maxYear} 
							value={selectedFilters['timabil'].length > 0 ? selectedFilters['timabil'] : [minYear, maxYear]} 
							range={true}
							styles={{
								handle: {
									borderColor: '#777',
									borderWidth: 1,
									backgroundColor: '#ccc',
									borderRadius: 4,
									height: 20,
									marginTop: -8
								},
								
								track: {
									backgroundColor: '#006841'
								}
							}}
							dotStyle={{
								borderColor: '#006841'
							}}
							marks={sliderMarks} 
							onChangeComplete={(event) => {
								updateUrl(selectedFilters);
							}} 
							onChange={(event) => {
								setTimeRangeValue(event);
								updateSelectedFilters('timabil', event, false);
							}} 
						/>
					</div>
					
				</div>

				<div className="flex flex-wrap gap-4 border-b pb-2 mb-4">
					<div className="flex flex-wrap gap-4 grow">
						{
							hasActiveFilters && filters.filter(filter => filter.type != 'label' && activeFilters[filter.searchParam] && activeFilters[filter.searchParam].length).map((filter, index) => {
								return <div key={index+filter.searchParam}>
									{
										filter.type == 'checklist' && filter.data && activeFilters[filter.searchParam].length > 0 && <div>
											<div className="font-bold text-sm mb-2">{filter.label}</div>
											{
												activeFilters[filter.searchParam].map((selection, sIndex) => <button key={selection+''+sIndex} className="inline-block p-2 rounded bg-gray-200 mr-2 mb-2 text-sm"
													onClick={() => {
														updateSelectedFilters(filter.searchParam, addOrRemove(activeFilters[filter.searchParam], selection), true);
													}}
												>
												{filter.filterLabelFunc ? filter.filterLabelFunc(selection) : _.findWhere(filter.data, {id: selection})[typeof filter.listLabelField === 'object' ? filter.listLabelField[props.currentLang] : filter.listLabelField]} <Icon icon={'close'} className={'float-right size-5 ml-2'} /></button>)
											}
										</div>
									}
									{
										filter.type == 'text' && activeFilters[filter.searchParam].length > 0 && <div>
											<div className="font-bold text-sm mb-2">{filter.label}</div>
											<button className="inline-block p-2 rounded bg-gray-200 mr-2 mb-2 text-sm" onClick={() => {
												updateSelectedFilters(filter.searchParam, '', true);
											}}>
												{activeFilters[filter.searchParam]} <Icon icon={'close'} className={'float-right size-5 ml-2'} />
											</button>										
										</div>
									}
									{
										filter.type == 'foreignId' && activeFilters[filter.searchParam].length > 0 && <div>
											<div className="font-bold text-sm mb-2">{filter.label}</div>
											<button className="inline-block p-2 rounded bg-gray-200 mr-2 mb-2 text-sm" onClick={() => {
												updateSelectedFilters(filter.searchParam, null, true);
											}}>
												<ForeignLabel apiEndpoint={filter.apiEndpoint} labelEndpointField={filter.labelEndpointField} idValue={activeFilters[filter.searchParam][0]}>
													<Icon icon={'close'} className={'float-right size-5 ml-2'} />
												</ForeignLabel>
											</button>										
										</div>
									}
									{
										filter.type == 'choicesdynamic' && activeFilters[filter.searchParam] && <div>
											<div className="font-bold text-sm mb-2">{filter.label}</div>
											<button className="inline-block p-2 rounded bg-gray-200 mr-2 mb-2 text-sm" onClick={() => {
												updateSelectedFilters(filter.searchParam, null, true);
											}}>
												<ForeignLabel apiEndpoint={filter.apiEndpoint} labelEndpointField={filter.labelEndpointField} labelFunc={(label) => window.l(label)} idValue={activeFilters[filter.searchParam]}>
													<Icon icon={'close'} className={'float-right size-5 ml-2'} />
												</ForeignLabel>
											</button>										
										</div>
									}
									{
										filter.type == 'range' && activeFilters[filter.searchParam].length > 0 && <div>
											<div className="font-bold text-sm mb-2">{filter.label}</div>
											<button className="inline-block p-2 rounded bg-gray-200 mr-2 mb-2 text-sm" onClick={() => {
												updateSelectedFilters(filter.searchParam, [], true);
											}}>
												{activeFilters[filter.searchParam].join('–')} <Icon icon={'close'} className={'float-right size-5 ml-2'} />
											</button>										
											
										</div>
									}
									{
										filter.type == 'choices' && activeFilters[filter.searchParam].length > 0 && <div>
											<div className="font-bold text-sm mb-2">{filter.label}</div>
											<button className="inline-block p-2 rounded bg-gray-200 mr-2 mb-2 text-sm" onClick={() => {
												updateSelectedFilters(filter.searchParam, null, true);
											}}>
												{filter.data[activeFilters[filter.searchParam]]} <Icon icon={'close'} className={'float-right size-5 ml-2'} />
											</button>										
											
										</div>
									}
								</div>
							})
						}
					</div>
					{
						props.filterRowContent
					}
				</div>

				<div className="relative">
					{
						props.showMap && props.mapData.length > 0 && <div>
							<div className="font-bold mb-2">{l('Places of origin')}</div>
							<MapView mapData={props.mapData} zoom={6} circleMarkers={true} popupContentFunc={(item) => <div>
								<div className="text-lg mb-2">{item.name}</div>
								{
									item.document_count && <div className="text-md mb-2">{item.document_count} {window.l('skjöl')}</div>
								}
								<button className="inline-block p-2 rounded bg-gray-200 mr-2 mb-2 text-sm" onClick={() => {
									updateSelectedFilters('stadur', item.id, true);
								}}>
									{window.l('View documents from this place')}
								</button>			
							</div>} />
						</div>
					}

					{props.children}
				</div>

			</div>

		</div>

	</Fragment>
}